<template>
  <div>
    <h1>Unsent scheduled quote emails</h1>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="count"
      :loading="loading"
      :headers="headers"
      :items="quoteEmails"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>
            <router-link
              :to="{ name: 'quote', params: { id: props.item.quoteid } }"
              >{{ props.item.quoteid }}</router-link
            >
          </td>
          <td>
            <span v-if="props.item.emailTemplateRevision">{{
              props.item.emailTemplateRevision.subject
            }}</span>
          </td>
          <td>
            <div v-if="props.item.quoteEmails">
              <div
                v-for="quoteEmail in props.item.quoteEmails"
                :key="quoteEmail.id"
              >
                <a :href="`mailto:${quoteEmail.email.address}`">{{
                  quoteEmail.email.address
                }}</a>
                <span>{{ ` (${quoteEmail.email.personal})` }}</span>
              </div>
            </div>
          </td>
          <td>{{ props.item.scheduled | formatDateTime }}</td>
          <td>
            <v-btn @click="deleteItem(props.item)" small>
              <v-icon>delete</v-icon> delete</v-btn
            >
            <v-btn
              @click="notifyItem(props.item)"
              small
              v-if="$keycloak.hasRealmRole('root')"
            >
              <v-icon>send</v-icon> notify</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "UnsentQuoteEmails",
  metaInfo() {
    return {
      title: "Quote emails",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      count: 0,
      quoteEmails: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Quote",
          value: "quoteid"
        },
        {
          text: "Subject",
          value: "emailTemplateRevision.subject"
        },
        {
          text: "Email",
          sortable: false
        },
        {
          text: "Scheduled",
          value: "scheduled"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true
    };
  },
  methods: {
    async fetchCount() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scheduledQuoteEmails/count`
      );
      // console.log(response.data)
      this.count = response.data;
    },
    async fetchQuoteEmails() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      // console.log("sort by: " + sortBy + ", sort descending: " + descending);
      let firstRow = (page - 1) * rowsPerPage;
      // console.log("article type: " + this.articleType + ", firstRow: " + firstRow + ", rowsPerPage: " + rowsPerPage);
      const response = await nbmlaw.get(
        `/cors/admin/sales/scheduledQuoteEmails`,
        {
          params: {
            first: firstRow,
            pageSize: rowsPerPage,
            sortBy,
            descending,
            filter: this.filter
          }
        }
      );
      // console.log(response.data);
      this.quoteEmails = response.data;
      this.loading = false;
    },
    async notifyItem(item) {
      try {
        await nbmlaw.put(
          `/cors/admin/sales/scheduledQuoteEmails/${item.id}`,
          null
        );
        this.update();
      } catch (err) {
        console.error(err);
      }
    },
    async deleteItem(item) {
      if (confirm("Are you sure?")) {
        try {
          await nbmlaw.delete(
            `/cors/admin/sales/scheduledQuoteEmails/${item.id}`
          );
          this.update();
        } catch (err) {
          console.error(err);
        }
      }
    },
    update() {
      this.loading = true;
      this.fetchCount();
      this.fetchQuoteEmails();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    }
  },
  created() {
    this.update();
  }
};
</script>
